
import Component from "vue-class-component";
import Vue from "vue";
import {Prop} from "vue-property-decorator";
import {MenuItemGroup} from "@/features/applications/components/NavApplication.vue";
import {RequirementFulfillmentStatus} from "@/api-client";
import NavApplicationMenuItem from "@/features/applications/components/NavApplicationMenuItem.vue";

@Component({
    components: {
        NavApplicationMenuItem
    }
})
export default class NavApplicationMenuItemGroup extends Vue {
    @Prop({required: true})
    item!: MenuItemGroup;

    @Prop({required: true})
    getIcon!: (status: RequirementFulfillmentStatus) => string;
    
    get status(): RequirementFulfillmentStatus {
        if (this.item.items.some(x => x.status == RequirementFulfillmentStatus.Accepted)) {
            return RequirementFulfillmentStatus.Accepted;
        }

        if (this.item.items.some(x => x.status == RequirementFulfillmentStatus.FulfilledAutomatically)) {
            return RequirementFulfillmentStatus.FulfilledAutomatically;
        }

        if (this.item.items.some(x => x.status == RequirementFulfillmentStatus.Fulfilled)) {
            return RequirementFulfillmentStatus.Fulfilled;
        }

        if (this.item.items.some(x => x.status == RequirementFulfillmentStatus.Rejected)) {
            return RequirementFulfillmentStatus.Rejected;
        }
        
        return RequirementFulfillmentStatus.Unfulfilled;
    }
}
